"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var login_component_1 = require("./components/login.component");
var auth_guard_1 = require("./guard/auth.guard");
var alert_component_1 = require("./directives/alert.component");
var alert_service_1 = require("./services/alert.service");
var authentication_service_1 = require("./services/authentication.service");
exports.ConfigureAuthenticationService = authentication_service_1.ConfigureAuthenticationService;
var PulseAuthenticationLibrary = (function () {
    function PulseAuthenticationLibrary() {
    }
    return PulseAuthenticationLibrary;
}());
PulseAuthenticationLibrary = __decorate([
    core_1.NgModule({
        imports: [],
        exports: [
            login_component_1.LoginComponent,
            auth_guard_1.AuthGuard,
            alert_component_1.AlertComponent,
            alert_service_1.AlertService,
            authentication_service_1.AuthenticationService
        ],
        declarations: [
            login_component_1.LoginComponent,
            alert_component_1.AlertComponent
        ],
        providers: [
            alert_service_1.AlertService,
            authentication_service_1.AuthenticationService,
            auth_guard_1.AuthGuard
        ],
    })
], PulseAuthenticationLibrary);
exports.PulseAuthenticationLibrary = PulseAuthenticationLibrary;
